export class PurposeStorage {
  private static STORAGE_KEY = "chosen_purpose";

  public static setPurpose(value: string): void {
    try {
      sessionStorage.setItem(PurposeStorage.STORAGE_KEY, value);
    } catch {
      // ignore (storage may be unavailable)
    }
  }

  public static getPurpose(): string {
    try {
      return sessionStorage.getItem(PurposeStorage.STORAGE_KEY) || "";
    } catch {
      return "";
    }
  }
}
